import {ReactElement} from 'react'
import {
    Dialog,
    DialogDisclosure,
    DialogDismiss,
    DialogHeader,
    DialogHeading,
    DialogBody
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogProvider, DialogStore} from '@ariakit/react'
import {AccessForm} from '../access-forms/AccessForm'
import {AccessFormProvider} from '../access-forms/AccessFormProvider'
import {AccessDialogFooter} from './AccessDialogFooter'
import {CreateAccessFormValidationSchema} from '../../formSchemas'

interface CreateAccessDialogProps {
    defaultValues?: Partial<CreateAccessFormValidationSchema>
    trigger?: ReactElement
    dialogStore?: DialogStore
}

export const CreateAccessDialog = ({defaultValues, trigger, dialogStore}: CreateAccessDialogProps) => {
    return (
        <DialogProvider store={dialogStore}>
            <DialogDisclosure render={trigger} />
            <Dialog width="680px" overflowY="unset">
                <CreateAccessDialogContent defaultValues={defaultValues} />
            </Dialog>
        </DialogProvider>
    )
}

const CreateAccessDialogContent = ({defaultValues}: {defaultValues?: Partial<CreateAccessFormValidationSchema>}) => {
    const {t} = useTranslation()

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('accesses:add_access')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <AccessFormProvider defaultValues={defaultValues}>
                <DialogBody>
                    <AccessForm />
                </DialogBody>
                <AccessDialogFooter />
            </AccessFormProvider>
        </>
    )
}
